import React from 'react';
import { StyledTagButton, StyledBadge } from './TagButton.style';

const TagButton = (props) => {
  return (<StyledTagButton {...props}>
    {props.children}
    {props.count && <StyledBadge className="material-icons">{props.count}</StyledBadge>}
  </StyledTagButton>)
};

export default TagButton;
